__turbopack_context__.v({
  "bubblePop": "_5MlfEq_bubblePop",
  "kidProfile": "_5MlfEq_kidProfile",
  "kidProfileContainer": "_5MlfEq_kidProfileContainer",
});
